<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-6"
        >
          <v-row>
            <v-col cols="12">
              <p class="text--secondary mb-4">
                Остальные данные заведения приезжают из Delivery и здесь не правятся.
                Реквизиты хранятся зашифрованными; сейчас они показываются в открытом
                виде — временно, на время отладки оплаты.
              </p>
              <v-alert
                v-if="secretsError"
                type="warning"
                text
                dense
              >
                {{ secretsError }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="isOnlinePaymentEnabled"
                label="Онлайн-оплата"
                hint="Выключено — гостям этого ресторана не предлагается оплата по ссылке и QR, даже если всё настроено"
                persistent-hint
                class="mt-0"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="accountNo"
                label="Номер счёта Bakai"
                :hint="hasAccountNo ? 'Задан' : 'Не задан'"
                persistent-hint
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="qrAuthToken"
                label="Токен QR-кода"
                :hint="hasQrAuthToken ? 'Задан' : 'Не задан'"
                persistent-hint
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="payLinkAuthToken"
                label="Токен платёжной ссылки"
                :hint="hasPayLinkAuthToken ? 'Задан' : 'Не задан'"
                persistent-hint
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'

export default {
  name: 'RestaurantForm',
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    rules,
  }),
  computed: {
    ...mapFormHandlers('restaurant/form', [
      'isOnlinePaymentEnabled',
      'accountNo',
      'qrAuthToken',
      'payLinkAuthToken',
    ]),
    ...mapState('restaurant/form', [
      'hasAccountNo',
      'hasQrAuthToken',
      'hasPayLinkAuthToken',
      'secretsError',
    ]),
  },
  watch: {
    show(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('restaurant/form', ['resetForm']),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
